import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import EventoVisualizarController from "../../DefaultPage/Evento/controller/evento-visualizar.controller";
import EventoService from "../../../services/evento.service";
import { isEventoInterno, ativarLayoutEventoInterno } from "../../../shared/utils/EventoInternoUtil";

export default function Evento() {
  const controller = new EventoVisualizarController(true);
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    const tipoToken = searchParams.get("tipo");

    let id = searchParams.get("CodigoAudiencia");
    if (tipoToken === "Tomada de Subsídios") {
      sessionStorage.setItem("tipoToken", tipoToken);
    }
    if (token) {
      sessionStorage.setItem("tokenInvite", token);
    }
    if (id) {
      sessionStorage.setItem("codAudienciaPublica", id);
    } else {
      const stored = sessionStorage.getItem("codAudienciaPublica");
      if (stored) {
        id = stored;
      }
    }

    if (!id) return;

    const navigate = async () => {
      try {
        const service = new EventoService();
        const res: any = await service.getEvento(id, 0);
        if (isEventoInterno(res?.result)) {
          sessionStorage.setItem("idEventoInterno", String(id));
          ativarLayoutEventoInterno();
          controller.history.push("/evento-interno", { id });
          return;
        }
      } catch (err) {
        console.error(err);
      }

      if (controller.isAuthenticated()) {
        controller.history.push("/evento/visualizar", { id });
      } else {
        controller.history.push("/public/evento/visualizar", { id });
      }
    };

    navigate();
  }, [location.search, controller]);

  return <div>Carregando...</div>;
}
